import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import incident_manager from '../api/incident';
import {loadCauses} from '../api/causes';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import MaterialTable, {MTableBodyRow} from 'material-table';
import { hasExactPrivilege, hasPrivileges } from '../util/auth';
import { LinkTwoTone, Videocam, Photo, VolumeUp } from '@material-ui/icons';
import { buildMediaObject, mediaExtensions } from '../util/media';
import { Tooltip } from '@material-ui/core';

export default function Incidents(props){
    var [incidents, setIncidents] = useState(null);
    var [message, setMessage] = useState(null);
    var [teamMode, setTeamMode] = useState(props&&props.teamMode?props.teamMode:false);

    var [causes, setCauses] = useState([])

	// race_edition_uci_race_category => ME/WE category 
	
    const columns = [
        { title: 'Incident ID', field: 'incident_id'},
        { title: 'Race name', field: 'racename'},
        { title: 'Category', field: 'category'},
        { title: 'Stage', field: 'stage_id'},
        { title: 'Incident time', field: 'incident_ts', defaultSort: 'desc', customSort: (a,b) => Date.parse(a.incident_ts)-Date.parse(b.incident_ts)},
        { title: 'Type', field: 'type', lookup: { 'CRASH': 'CRASH', 'NO CRASH': 'NO CRASH'}},
        { title: 'Km to finish', field: 'incident_km_from_finish'},
        { 
            title: 'causes', 
            field: 'causes',
            lookup: causes.reduce((acc, cause) => { 
                acc[cause.cause_id] = cause.cause_description; 
                return acc; 
            }, {}),
            render: rowData => {
                const causesMapped = (Array.isArray(rowData.causes) ? rowData.causes : [])
                    .map(causeIdx => causes.find(c => c.cause_id === causeIdx)?.cause_description)
                    .filter(Boolean);

                return causesMapped.length === 0 ? (<span>0</span>) : (
                    <Tooltip
                        title={<div style={{ whiteSpace: 'pre-line' }}>{causesMapped.join('\n')}</div>}
                        arrow
                    >
                        <span>{causesMapped.length}</span>
                    </Tooltip>
                );
            },
            customFilterAndSearch: (term, rowData) => {
                if (!term || term.length === 0) return true;
                return term.some(t => rowData.causes?.includes(parseInt(t)));
            },
        },
        { title: 'Severity (0-10)', field: 'incident_severity'
        },
        { 
            title: '# involved riders', 
            field: 'incident_involved_riders',
            customFilterAndSearch: (term, rowData) => {
                if (term === '') return true;
                const exactMatch = true;
                return exactMatch 
                    ? String(rowData.incident_involved_riders) === String(term) 
                    : String(rowData.incident_involved_riders).includes(String(term));
            },
        }, 
        { title: 'Media', field: 'incident_media'}, 			
        { title: 'Analyst status', field: 'incident_analysis_status', lookup: { 'Complete': 'Complete', 'Pending': 'Pending'}},
        { title: 'Actions', field: 'incident_actions'}
    ];

    /*
    if (hasPrivileges('admin')) columns.splice(columns.length - 1, 0, { 
        title: 'Analyst status', 
        field: 'incident_analysis_status', 
        lookup: { 'Complete': 'Complete', 'Pending': 'Pending'},
    });
    */

    const confirmDialog = incident_id => {
        confirmAlert({
          title: 'Confirm to submit',
          message: 'Are you sure you want to delete the incident '+incident_id+"?",
          buttons: [
            {
              label: 'Yes',
              onClick: () => {
                  incident_manager.remove_incident({'incident_id': incident_id}).then((res)=>{
                      setMessage("Successfully removed incident "+incident_id);
                      teamMode?load_team_incidents():load_incidents();
                  })
              }
            },
            {
              label: 'No',
              onClick: () =>{
                  setMessage("");
              }
            }
          ]
        });
      };
    
    let load_incidents = () => {
        incident_manager.get_incidents().then((response) =>{
            var incident_rows = []
			
            Object.values(response).forEach((incident)=>{
                const icons = [];
                if ('media' in incident && incident['media'] != null) {
                    const mediaObject = buildMediaObject(incident['media'].split(',')
                        .map(x => ({ incident_media_url: x, incident_media_id: -1 })), false, true);

                    const iconCombination = { 'video': <Videocam />, 'audio': <VolumeUp />, 'image': <Photo />, 'link': <LinkTwoTone />, 'pdf': <LinkTwoTone /> };
                    Object.keys(mediaExtensions).forEach(ext => {
                        if (mediaObject[ext].length > 0) {
                            icons.push(iconCombination[ext]);
                        }
                    });
                }

                let analysis_action = '';
                if (incident['incident_require_analyst']) {
                    analysis_action = incident['incident_analysis_complete']
                        ? 'Complete'
                        : 'Pending';
                }

				incident_rows.push({
                    incident_id: incident['incident_id'],
                    racename: incident["race_name"],
					category: incident["race_edition_uci_race_category"],
					type: incident["incident_type"],
                    incident_ts: incident['incident_timestamp'],
					incident_km_from_finish: incident["incident_km_from_finish"],
                    incident_severity: incident['incident_severity'],
                    incident_involved_riders: incident["involved_riders"],
                    incident_num_causes: incident["incident_causes"],
                    incident_require_analyst: incident["incident_require_analyst"],
					stage_id: incident["race_stage_index"],
                    causes: incident['causes'],
					incident_media: <div>{icons}</div>,
                    incident_actions: <div className='incident-actions'><Link className='btn btn-theme' to={`/incident/${incident['incident_id']}`}>View</Link>{hasPrivileges("commissaire")?<span className='btn btn-danger' onClick={()=>confirmDialog(incident.incident_id)}>Delete</span>:""}</div>,
                    incident_analysis_status: analysis_action,
                })

            })
			setIncidents(incident_rows);
        });
    }

    let load_team_incidents = () => {
        incident_manager.get_team_incidents().then((response) =>{
            var incident_rows = []
            Object.values(response).forEach((incident)=>{
                incident_rows.push({
                    incident_id: incident['incident_id'],
                    racename: incident["race_name"],					
					category: incident["race_edition_uci_race_category"],
					type: incident["incident_type"],
                    incident_ts: incident['incident_timestamp'],
					incident_km_from_finish: incident["incident_km_from_finish"],
                    incident_severity: incident['incident_severity'],
                    incident_involved_riders: incident["involved_riders"],
                    incident_num_causes: incident["incident_causes"],
					stage_id: incident["race_stage_index"],
                    causes: incident['causes'],					
					incident_media: incident["incident_media"],
                    incident_actions: <div className='incident-actions'><Link className='btn btn-theme' to={`/incident/${incident['incident_id']}`}>View</Link>{hasPrivileges("commissaire")?<span className='btn btn-danger' onClick={()=>confirmDialog(incident.incident_id)}>Delete</span>:""}</div>,
                })
            })
            setIncidents(incident_rows);
        });
    }

    let load_causes = () =>{
        loadCauses().then((response)=>{
            setCauses(response)
        })
    }

    useEffect(()=>{
        teamMode?load_team_incidents():load_incidents();
        load_causes();
    }, [teamMode]);

    if (incidents) {
        return (
            <div>
                <h1>Incidents</h1>
                <span>{message}</span>
                <span className='filter-team'>
                    {hasExactPrivilege('staff')?<span class="badge">{teamMode?"You're currently viewing your team's incidents only.":"You're currently viewing all incidents"}</span>:""}
                    {hasExactPrivilege('staff')?<button className={`btn btn-${teamMode?"warning":"success"}`} onClick={()=>setTeamMode(!teamMode)}>{teamMode?"Show all incidents":"Show my team's incidents only"}</button>:""}
                </span>

                <MaterialTable
                    title="Incidents"
                    columns={columns}
                    data={incidents}
                    options={{
                        filtering: true,
                        paging: true,
                        pageSize: 20,
                        pageSizeOptions: [20, 50, 100],
                        sorting: true,
                        debounceInterval: 1000
                    }}
                    components={{
                        Row: props => <MTableBodyRow {...props}/>,
                        Toolbar: props => {
                            const filteredIncidentCount = props.dataManager?.filteredData.length ?? incidents.length;
                            const incidentLabel = filteredIncidentCount === 1 ? 'incident' : 'incidents';

                            return (
                                <div className="incident-result-count">
                                    Showing {filteredIncidentCount} of {incidents.length} {incidentLabel}
                                </div>
                            );
                        }
                    }}
                />
            </div>
        )
    }
    else{
        return (<div><h1>Incidents</h1><p>Loading incidents...</p></div>)
    }
}
